// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35M6e","left":"styles_left__2BZKi","desktopActions":"styles_desktopActions__ivUsP","title":"styles_title__3k76u"};